import {mapObject} from '@benchling/js-utils';

import * as logging from './Logging';

const DEFAULT_MAX_DEPTH = 7;
const DEFAULT_SUBSTITUTE = '[...]';

function isPrimitive(obj: unknown): boolean {
  return obj == null || typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean';
}

function truncate(obj: unknown, maxDepth: number, curDepth: number, substitute: string): unknown {
  if (curDepth >= maxDepth) {
    return substitute;
  } else if (isPrimitive(obj)) {
    return obj;
  } else if (Array.isArray(obj)) {
    return obj.map((val) => truncate(val, maxDepth, curDepth + 1, substitute));
  } else {
    return mapObject(obj as {[id: string]: unknown}, (val: unknown) =>
      truncate(val, maxDepth, curDepth + 1, substitute)
    );
  }
}

export default function truncateJSON(
  obj: unknown,
  options: {maxDepth?: number; substitute?: string} = {}
): unknown {
  try {
    return truncate(obj, options.maxDepth ?? DEFAULT_MAX_DEPTH, 0, options.substitute ?? DEFAULT_SUBSTITUTE);
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (e) {
    logging.warn('Failed to truncate object', {
      extra: {obj, options},
    });
    return '<JSON_PROCESSING_ERROR>';
  }
}
